module.exports = __webpack_public_path__ + "img/1.4fb3ae82.jpg";